/* eslint-disable @typescript-eslint/no-explicit-any */
import { ICompany } from "../types/company";
import { ICropType } from "../types/cropType";
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";

const routePrefix = "datalake/crop-type";

export default {
  async get({
    page,
    pageSize,
    searchTerm,
  }: {
    page: number;
    pageSize: number;
    searchTerm?: string;
  }): Promise<ICropType[]> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/get`, {
        page,
        pageSize,
        searchTerm,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load crop types."
        );
        return [];
      }
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load crop types."
        );
      }
      return [];
    }
  },
  async update({
    id,
    updateData,
  }: {
    id: string;
    updateData: Partial<ICropType>;
  }): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/update`, {
        id,
        updateData,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not save the crop type."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save the crop type."
        );
      }
      return null;
    }
  },
  async addNewCropType(cropType: ICropType): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/create`, {
        cropType,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not save the crop type."
        );
        return null;
      }
      showSnackbar(
        "success",
        "Success",
        result?.data.message || "Crop type created."
      );
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save the crop type."
        );
        return null;
      }
    }
  },
  async delete({ id }: { id: string }): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/delete`, {
        id,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not delete the crop type."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not delete the crop type."
        );
      }
      return null;
    }
  },
  async addAssignedCompanies({
    id,
    companyIds,
    companyIdToPredictionTargets,
  }: {
    id: string;
    companyIds: string[];
    companyIdToPredictionTargets: {
      [key: string]: string[];
    };
  }): Promise<any> {
    try {
      const result = await backendApi()?.post(
        `${routePrefix}/assign-companies`,
        {
          id,
          companyIds,
          companyIdToPredictionTargets,
        }
      );
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not assign those companies."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not assign those companies."
        );
      }
      return null;
    }
  },
  async removeAssignedCompanies({
    id,
    companyIds,
  }: {
    id: string;
    companyIds: string[];
  }): Promise<any> {
    try {
      const result = await backendApi()?.post(
        `${routePrefix}/remove-companies`,
        {
          id,
          companyIds,
        }
      );
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not remove those companies."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not remove those companies."
        );
      }
      return null;
    }
  },
  async updateCompanyPredictions({
    companies,
  }: {
    companies: ICompany[];
  }): Promise<any> {
    try {
      const result = await backendApi()?.post(
        `${routePrefix}/update-company-predictions`,
        {
          companies,
        }
      );
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not update the company predictions."
        );
        return null;
      }
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not update the company predictions."
        );
      }
      return null;
    }
  },
};
